const Paths = {
  spMap: [
    { link: "/sp/map", name: "Ситуационное управление" },
    { name: "Карта" },
  ],
  spReestr: [
    { link: "/sp/reestr", name: "Ситуационное управление" },
    { name: "Реестр дефектов" },
  ],
  spAnalytics: [
    { link: "/sp/analytics", name: "Ситуационное управление" },
    { name: "Аналитика" },
  ],
  spReports: [
    { link: "/sp/reports", name: "Ситуационное управление" },
    { name: "Отчеты" },
  ],
  spNotifSettings: [
    { link: "/sp/notif-settings", name: "Ситуационное управление" },
    { name: "Настройка рассылок" },
  ],
  spNotifHistory: [
    { link: "/sp/notif-history", name: "Ситуационное управление" },
    { name: "История рассылок" },
  ],

  nsiSystem: [
    { link: "/nsi/system", name: "Справочники и классификаторы" },
    { name: "Системные справочники и классификаторы" },
  ],
  nsiСustom: [
    { link: "/nsi/custom", name: "Справочники и классификаторы" },
    { name: "Пользовательские справочники и классификаторы" },
  ],
  nsiOrganizations: [
    {
      link: "/nsi/organizations-and-buildings",
      name: "Справочники и классификаторы",
    },
    { name: "Организации и здания" },
  ],

  adminUsers: [
    { link: "/admin/users", name: "Администрирование" },
    { name: "Пользователи" },
  ],
  adminRoles: [
    { link: "/admin/roles", name: "Администрирование" },
    { name: "Роли" },
  ],
  adminMatrix: [
    { link: "/admin/matrix", name: "Администрирование" },
    { name: "Матрица прав" },
  ],
  adminLoggingPermissions: [
    { link: "/admin/logging/permissions", name: "Администрирование" },
    { link: "/admin/logging/permissions", name: "Логирование" },
    { name: "Действия пользователя" },
  ],
  adminSystemSettings: [
    { link: "/admin/system-settings/routes", name: "Администрирование" },
    { name: "Настройка маршрутов согласования" },
  ],
  adminMenu: [
    { link: "/admin/menu", name: "Администрирование" },
    { link: "/admin/menu", name: "Системные настройки" },
    { name: "Меню" },
  ],
  adminSystemSession: [
    { link: "/admin/system/session", name: "Администрирование" },
    { link: "/admin/system/session", name: "Системные настройки" },
    { name: "Настройки сессии" },
  ],
  adminSitpanelSetting: [
    { link: "/admin/system/sitpanel", name: "Администрирование" },
    { link: "/admin/system/sitpanel", name: "Системные настройки" },
    { name: "Настройка СитПанели" },
  ],
  adminSystemIntegrations: [
    { link: "/admin/system/integrations", name: "Администрирование" },
    { link: "/admin/system/integrations", name: "Системные настройки" },
    { name: "Интеграции" },
  ],
};

export default Paths;
